import { Component, OnInit, Input } from '@angular/core';
import { KeyDatesService } from 'src/app/shared/services/keydates.service';
import { DateTime } from 'luxon';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-key-dates-history',
  templateUrl: './key-dates-history.component.html',
  styleUrls: ['./key-dates-history.component.scss']
})
export class KeyDatesHistoryComponent implements OnInit {

  @Input() caseId: number = -1;
  keyDates: any;

  displayedColumns: string[] = ['keyDateType', 'value', 'enteredOn', 'enteredByUser', 'removedByUser', 'removedDate', 'removalReason'];


  constructor(public activeModal: NgbActiveModal,
              private keyDatesService: KeyDatesService)
  {
  }

  ngOnInit(): void {
    this.loadHistory();
  }

  loadHistory(){

    this.keyDatesService.getAllKeyDatesForCase(this.caseId).subscribe(result => {

      this.keyDates = result.keyDates;

    }, error => {

      var errorMessage = "Failed to get key dates history";
      if (error.error !== null && error.error.message !== undefined) {
        errorMessage = error.error.message;
      }

    });

  }

  formatDateWithTime(inDate : any){

   var formattedDate = '';


    if(inDate !== null)
    {

      var dt = DateTime.fromISO(inDate);

      formattedDate = dt.toFormat("dd-MM-yyyy HH:mm:ss");

    if(formattedDate == 'Invalid date')
      formattedDate = '';

    }


    return formattedDate;

  }

  formatDateOnly(inDate: any){

    var formattedDate = '';


    if(inDate !== null)
    {

      var dt = DateTime.fromISO(inDate);

      formattedDate = dt.toFormat("dd-MM-yyyy");

    if(formattedDate == 'Invalid date')
      formattedDate = '';

    }


    return formattedDate;

  }


  cancel(){
    this.activeModal.dismiss();
  }

}
